import MercadoPagoIcon from '@/assets/icons/MercadoPagoIcon';
import OxxoIcon from '@/assets/icons/OxxoIcon';
import ShortPagaleveIcon from '@/assets/icons/ShortPagaleveIcon';
import PayPalIcon from '@/assets/icons/PaypalIcon';
import SpeiIcon from '@/assets/icons/SpeiIcon';
import {
  filterSupportedPaymentMethodTypes,
  isSupportedPaymentMethodType,
  BACKEND_MANAGED_PAYMENT_METHOD_TYPES,
} from '@/consts/payment-method-types';

export { filterSupportedPaymentMethodTypes, isSupportedPaymentMethodType, BACKEND_MANAGED_PAYMENT_METHOD_TYPES };

export const PAYMENT_METHODS_ICONS = {
    pix: (
        <svg
            fill="currentColor"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className="box-border h-7 w-7"
        >
            <path d="M11.917 11.71a2.046 2.046 0 0 1-1.454-.602l-2.1-2.1a.4.4 0 0 0-.551 0l-2.108 2.108a2.044 2.044 0 0 1-1.454.602h-.414l2.66 2.66c.83.83 2.177.83 3.007 0l2.667-2.668h-.253zM4.25 4.282c.55 0 1.066.214 1.454.602l2.108 2.108a.39.39 0 0 0 .552 0l2.1-2.1a2.044 2.044 0 0 1 1.453-.602h.253L9.503 1.623a2.127 2.127 0 0 0-3.007 0l-2.66 2.66h.414z" />
            <path d="m14.377 6.496-1.612-1.612a.307.307 0 0 1-.114.023h-.733c-.379 0-.75.154-1.017.422l-2.1 2.1a1.005 1.005 0 0 1-1.425 0L5.268 5.32a1.448 1.448 0 0 0-1.018-.422h-.9a.306.306 0 0 1-.109-.021L1.623 6.496c-.83.83-.83 2.177 0 3.008l1.618 1.618a.305.305 0 0 1 .108-.022h.901c.38 0 .75-.153 1.018-.421L7.375 8.57a1.034 1.034 0 0 1 1.426 0l2.1 2.1c.267.268.638.421 1.017.421h.733c.04 0 .079.01.114.024l1.612-1.612c.83-.83.83-2.178 0-3.008z" />
        </svg>
    ),
    pix_auto: (
        <svg
            fill="currentColor"
            width="800px"
            height="800px"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className="box-border h-8 w-8"
        >
            <path d="M11.917 11.71a2.046 2.046 0 0 1-1.454-.602l-2.1-2.1a.4.4 0 0 0-.551 0l-2.108 2.108a2.044 2.044 0 0 1-1.454.602h-.414l2.66 2.66c.83.83 2.177.83 3.007 0l2.667-2.668h-.253zM4.25 4.282c.55 0 1.066.214 1.454.602l2.108 2.108a.39.39 0 0 0 .552 0l2.1-2.1a2.044 2.044 0 0 1 1.453-.602h.253L9.503 1.623a2.127 2.127 0 0 0-3.007 0l-2.66 2.66h.414z" />
            <path d="m14.377 6.496-1.612-1.612a.307.307 0 0 1-.114.023h-.733c-.379 0-.75.154-1.017.422l-2.1 2.1a1.005 1.005 0 0 1-1.425 0L5.268 5.32a1.448 1.448 0 0 0-1.018-.422h-.9a.306.306 0 0 1-.109-.021L1.623 6.496c-.83.83-.83 2.177 0 3.008l1.618 1.618a.305.305 0 0 1 .108-.022h.901c.38 0 .75-.153 1.018-.421L7.375 8.57a1.034 1.034 0 0 1 1.426 0l2.1 2.1c.267.268.638.421 1.017.421h.733c.04 0 .079.01.114.024l1.612-1.612c.83-.83.83-2.178 0-3.008z" />
        </svg>
    ),
    boleto: (
        <svg
            fill="currentColor"
            width="800px"
            height="800px"
            viewBox="-4 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            className="box-border h-7 w-7"
        >
            <path d="M0 25.281h0.781v-18.563h-0.781v18.563zM2.344 25.281h1.531v-18.563h-1.531v18.563zM5.406 25.281h1.563v-18.563h-1.563v18.563zM8.5 25.281h3.125v-18.563h-3.125v18.563zM13.156 25.281h2.344v-18.563h-2.344v18.563zM17.031 25.281h1.563v-18.563h-1.563v18.563zM20.125 25.281h0.781v-18.563h-0.781v18.563zM22.469 25.281h1.531v-18.563h-1.531v18.563z" />
        </svg>
    ),
    credit_card: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
            className="box-border h-7 w-7"
        >
            <path
                fill="currentColor"
                d="M2.5 4A1.5 1.5 0 001 5.5V6h18v-.5A1.5 1.5 0 0017.5 4h-15zM19 8.5H1v6A1.5 1.5 0 002.5 16h15a1.5 1.5 0 001.5-1.5v-6zM3 13.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.75-.75a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z"
                clipRule="evenodd"
            />
        </svg>
    ),
    picpay: (
        <svg
            width="25"
            height="22"
            viewBox="0 0 25 22"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.963 0.586975V8.12397H24.5V0.586975H16.963ZM18.219 1.84298H23.244V6.86798H18.219V1.84298ZM19.475 3.09898V5.61198H21.988V3.09898H19.475ZM4.27 4.35498V7.52997H7.646C9.788 7.52997 11.004 8.56997 11.004 10.469C11.004 12.416 9.788 13.48 7.646 13.48H4.269L4.27 7.52997H0.5V21.414H4.269V16.654H7.839C12.172 16.654 14.654 14.302 14.654 10.334C14.654 6.56297 12.172 4.35598 7.84 4.35598L4.27 4.35498Z"
                fill="currentColor"
            />
        </svg>
    ),
    applepay: (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            className="box-border h-7 w-7"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.5502 20.28C16.5702 21.23 15.5002 21.08 14.4702 20.63C13.3802 20.17 12.3802 20.15 11.2302 20.63C9.79016 21.25 9.03016 21.07 8.17016 20.28C3.29016 15.25 4.01016 7.59 9.55016 7.31C10.9002 7.38 11.8402 8.05 12.6302 8.11C13.8102 7.87 14.9402 7.18 16.2002 7.27C17.7102 7.39 18.8502 7.99 19.6002 9.07C16.4802 10.94 17.2202 15.05 20.0802 16.2C19.5102 17.7 18.7702 19.19 17.5402 20.29L17.5502 20.28ZM12.5302 7.25C12.3802 5.02 14.1902 3.18 16.2702 3C16.5602 5.58 13.9302 7.5 12.5302 7.25Z"
                fill="currentColor"
            />
        </svg>
    ),
    googlepay: (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.9307 8.69785C20.0474 9.36901 20.1055 10.0491 20.1044 10.7303C20.1044 13.7727 19.0169 16.3451 17.1245 18.0863H17.127C15.4721 19.615 13.1971 20.5 10.4997 20.5C7.84761 20.5 5.30415 19.4465 3.42884 17.5712C1.55354 15.6958 0.5 13.1524 0.5 10.5003C0.5 7.84821 1.55354 5.30475 3.42884 3.42944C5.30415 1.55413 7.84761 0.500597 10.4997 0.500597C12.9818 0.472956 15.3786 1.40534 17.1895 3.10302L14.3346 5.95793C13.3024 4.97453 11.9252 4.43587 10.4997 4.45798C7.89103 4.45798 5.67484 6.21793 4.88487 8.58785C4.46675 9.82982 4.46675 11.1745 4.88487 12.4165H4.88862C5.68234 14.7827 7.89478 16.5426 10.5035 16.5426C11.8509 16.5426 13.0084 16.1976 13.9058 15.5876H13.9021C14.4233 15.2425 14.8692 14.7953 15.2127 14.273C15.5562 13.7508 15.7903 13.1643 15.9008 12.549H10.4997V8.6991L19.9307 8.69785Z"
                fill="currentColor"
            />
        </svg>
    ),
    openfinance_nubank: (
        <svg
            width="25"
            height="24"
            viewBox="0 0 500 275.9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M90.3 26.3C106.1 9.7 127 0 151.7 0c48 0 79.8 35 85.9 87.5 2 17.1 2 41.1 1.9 68.9v113h-66v-77.1s-.1-66-.5-78.4c-1.8-53.7-33.6-87.5-82.7-87.6-14.9 15.8-22.8 34.9-24 64.2-.2 4.1-.1 18.6-.1 37.6 0 9.9.1 21 .1 32.6v108.8H.3V150.8c0-4.1-.1-8.2-.1-12.3-.1-8.3-.3-16.6.1-24.9.7-13.8 3.1-27.4 9.6-40 14.7-28.8 44.9-47.4 77-47.4 1.1 0 2.2.1 3.4.1z"
                fill="currentColor"
            />
            <path
                d="M499.7 162.3c.4-8.3.3-16.6.1-24.9-.1-4.1-.1-8.2-.1-12.3V6.4h-66v108.8c0 11.6 0 22.7.1 32.6.1 19.1.1 33.6-.1 37.6-1.2 29.3-9.1 48.4-23.9 64.1-49.1 0-81-33.8-82.7-87.5-.4-12.3-.6-43-.6-78.4V6.3l-66 .1v113c0 27.8 0 51.9 1.9 68.9 6.1 52.5 37.9 87.5 85.9 87.5 24.6 0 45.6-9.7 61.4-26.3 1.1 0 2.2.1 3.4.1 32.2 0 62.3-18.6 77-47.4 6.5-12.6 8.9-26.1 9.6-39.9z"
                fill="currentColor"
            />
        </svg>
    ),
    paypal_wallet: <PayPalIcon className="box-border h-7 w-7" />,
    mercadopago_wallet: <MercadoPagoIcon className="box-border h-7 w-7" />,
    pagaleve: <ShortPagaleveIcon className="box-border h-7 w-7" />,
    oxxo: <OxxoIcon className="box-border h-7 w-auto" />,
    spei: <SpeiIcon className="box-border h-7 w-auto" />,
    multi_card: (
        <span className="relative inline-flex h-7 w-9 items-center">
            <span className="absolute left-0 opacity-50"><svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
            className="box-border h-7 w-7"
        >
            <path
                fill="currentColor"
                d="M2.5 4A1.5 1.5 0 001 5.5V6h18v-.5A1.5 1.5 0 0017.5 4h-15zM19 8.5H1v6A1.5 1.5 0 002.5 16h15a1.5 1.5 0 001.5-1.5v-6zM3 13.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.75-.75a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z"
                clipRule="evenodd"
            />
        </svg></span>
            <span className="absolute left-2"><svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
            className="box-border h-7 w-7"
        >
            <path
                fill="currentColor"
                d="M2.5 4A1.5 1.5 0 001 5.5V6h18v-.5A1.5 1.5 0 0017.5 4h-15zM19 8.5H1v6A1.5 1.5 0 002.5 16h15a1.5 1.5 0 001.5-1.5v-6zM3 13.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.75-.75a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z"
                clipRule="evenodd"
            />
        </svg></span>
        </span>
    ),
    card_pix: (
        <span className="inline-flex items-center gap-1">
            <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
            className="box-border h-7 w-7"
        >
            <path
                fill="currentColor"
                d="M2.5 4A1.5 1.5 0 001 5.5V6h18v-.5A1.5 1.5 0 0017.5 4h-15zM19 8.5H1v6A1.5 1.5 0 002.5 16h15a1.5 1.5 0 001.5-1.5v-6zM3 13.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.75-.75a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z"
                clipRule="evenodd"
            />
        </svg>
            <svg
                fill="currentColor"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                className="box-border h-5 w-5"
            >
                <path d="M11.917 11.71a2.046 2.046 0 0 1-1.454-.602l-2.1-2.1a.4.4 0 0 0-.551 0l-2.108 2.108a2.044 2.044 0 0 1-1.454.602h-.414l2.66 2.66c.83.83 2.177.83 3.007 0l2.667-2.668h-.253zM4.25 4.282c.55 0 1.066.214 1.454.602l2.108 2.108a.39.39 0 0 0 .552 0l2.1-2.1a2.044 2.044 0 0 1 1.453-.602h.253L9.503 1.623a2.127 2.127 0 0 0-3.007 0l-2.66 2.66h.414z" />
                <path d="m14.377 6.496-1.612-1.612a.307.307 0 0 1-.114.023h-.733c-.379 0-.75.154-1.017.422l-2.1 2.1a1.005 1.005 0 0 1-1.425 0L5.268 5.32a1.448 1.448 0 0 0-1.018-.422h-.9a.306.306 0 0 1-.109-.021L1.623 6.496c-.83.83-.83 2.177 0 3.008l1.618 1.618a.305.305 0 0 1 .108-.022h.901c.38 0 .75-.153 1.018-.421L7.375 8.57a1.034 1.034 0 0 1 1.426 0l2.1 2.1c.267.268.638.421 1.017.421h.733c.04 0 .079.01.114.024l1.612-1.612c.83-.83.83-2.178 0-3.008z" />
            </svg>
        </span>
    ),
};

export const PAYMENT_METHODS_ICONS_WITH_NAME = {
    pix: {
        name: "PIX",
        icon: (
            <svg
                fill="currentColor"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                className="box-border h-7 w-7"
            >
                <path d="M11.917 11.71a2.046 2.046 0 0 1-1.454-.602l-2.1-2.1a.4.4 0 0 0-.551 0l-2.108 2.108a2.044 2.044 0 0 1-1.454.602h-.414l2.66 2.66c.83.83 2.177.83 3.007 0l2.667-2.668h-.253zM4.25 4.282c.55 0 1.066.214 1.454.602l2.108 2.108a.39.39 0 0 0 .552 0l2.1-2.1a2.044 2.044 0 0 1 1.453-.602h.253L9.503 1.623a2.127 2.127 0 0 0-3.007 0l-2.66 2.66h.414z" />
                <path d="m14.377 6.496-1.612-1.612a.307.307 0 0 1-.114.023h-.733c-.379 0-.75.154-1.017.422l-2.1 2.1a1.005 1.005 0 0 1-1.425 0L5.268 5.32a1.448 1.448 0 0 0-1.018-.422h-.9a.306.306 0 0 1-.109-.021L1.623 6.496c-.83.83-.83 2.177 0 3.008l1.618 1.618a.305.305 0 0 1 .108-.022h.901c.38 0 .75-.153 1.018-.421L7.375 8.57a1.034 1.034 0 0 1 1.426 0l2.1 2.1c.267.268.638.421 1.017.421h.733c.04 0 .079.01.114.024l1.612-1.612c.83-.83.83-2.178 0-3.008z" />
            </svg>
        )
    },
    pix_auto: {
        name: "PIX Automático",
        icon: (
            <svg
                fill="currentColor"
                width="800px"
                height="800px"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                className="box-border h-8 w-8"
            >
                <path d="M11.917 11.71a2.046 2.046 0 0 1-1.454-.602l-2.1-2.1a.4.4 0 0 0-.551 0l-2.108 2.108a2.044 2.044 0 0 1-1.454.602h-.414l2.66 2.66c.83.83 2.177.83 3.007 0l2.667-2.668h-.253zM4.25 4.282c.55 0 1.066.214 1.454.602l2.108 2.108a.39.39 0 0 0 .552 0l2.1-2.1a2.044 2.044 0 0 1 1.453-.602h.253L9.503 1.623a2.127 2.127 0 0 0-3.007 0l-2.66 2.66h.414z" />
                <path d="m14.377 6.496-1.612-1.612a.307.307 0 0 1-.114.023h-.733c-.379 0-.75.154-1.017.422l-2.1 2.1a1.005 1.005 0 0 1-1.425 0L5.268 5.32a1.448 1.448 0 0 0-1.018-.422h-.9a.306.306 0 0 1-.109-.021L1.623 6.496c-.83.83-.83 2.177 0 3.008l1.618 1.618a.305.305 0 0 1 .108-.022h.901c.38 0 .75-.153 1.018-.421L7.375 8.57a1.034 1.034 0 0 1 1.426 0l2.1 2.1c.267.268.638.421 1.017.421h.733c.04 0 .079.01.114.024l1.612-1.612c.83-.83.83-2.178 0-3.008z" />
            </svg>
        )
    },
    boleto: {
        name: "Boleto",
        icon: (
            <svg
                fill="currentColor"
                width="800px"
                height="800px"
                viewBox="-4 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                className="box-border h-7 w-7"
            >
                <path d="M0 25.281h0.781v-18.563h-0.781v18.563zM2.344 25.281h1.531v-18.563h-1.531v18.563zM5.406 25.281h1.563v-18.563h-1.563v18.563zM8.5 25.281h3.125v-18.563h-3.125v18.563zM13.156 25.281h2.344v-18.563h-2.344v18.563zM17.031 25.281h1.563v-18.563h-1.563v18.563zM20.125 25.281h0.781v-18.563h-0.781v18.563zM22.469 25.281h1.531v-18.563h-1.531v18.563z" />
            </svg>
        )
    },
    credit_card: {
        name: `Cartão de Crédito`,
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                className="box-border h-7 w-7"
            >
                <path
                    fill="currentColor"
                    d="M2.5 4A1.5 1.5 0 001 5.5V6h18v-.5A1.5 1.5 0 0017.5 4h-15zM19 8.5H1v6A1.5 1.5 0 002.5 16h15a1.5 1.5 0 001.5-1.5v-6zM3 13.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.75-.75a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z"
                    clipRule="evenodd"
                />
            </svg>
        )
    },
    picpay: {
        name: "PicPay",
        icon: (
            <svg
                width="25"
                height="22"
                viewBox="0 0 25 22"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16.963 0.586975V8.12397H24.5V0.586975H16.963ZM18.219 1.84298H23.244V6.86798H18.219V1.84298ZM19.475 3.09898V5.61198H21.988V3.09898H19.475ZM4.27 4.35498V7.52997H7.646C9.788 7.52997 11.004 8.56997 11.004 10.469C11.004 12.416 9.788 13.48 7.646 13.48H4.269L4.27 7.52997H0.5V21.414H4.269V16.654H7.839C12.172 16.654 14.654 14.302 14.654 10.334C14.654 6.56297 12.172 4.35598 7.84 4.35598L4.27 4.35498Z"
                    fill="currentColor"
                />
            </svg>
        )
    },
    applepay: {
        name: "Apple Pay",
        icon: (
            <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                className="box-border h-7 w-7"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M17.5502 20.28C16.5702 21.23 15.5002 21.08 14.4702 20.63C13.3802 20.17 12.3802 20.15 11.2302 20.63C9.79016 21.25 9.03016 21.07 8.17016 20.28C3.29016 15.25 4.01016 7.59 9.55016 7.31C10.9002 7.38 11.8402 8.05 12.6302 8.11C13.8102 7.87 14.9402 7.18 16.2002 7.27C17.7102 7.39 18.8502 7.99 19.6002 9.07C16.4802 10.94 17.2202 15.05 20.0802 16.2C19.5102 17.7 18.7702 19.19 17.5402 20.29L17.5502 20.28ZM12.5302 7.25C12.3802 5.02 14.1902 3.18 16.2702 3C16.5602 5.58 13.9302 7.5 12.5302 7.25Z"
                    fill="currentColor"
                />
            </svg>
        )
    },
    googlepay: {
        name: "Google Pay",
        icon: (
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.9307 8.69785C20.0474 9.36901 20.1055 10.0491 20.1044 10.7303C20.1044 13.7727 19.0169 16.3451 17.1245 18.0863H17.127C15.4721 19.615 13.1971 20.5 10.4997 20.5C7.84761 20.5 5.30415 19.4465 3.42884 17.5712C1.55354 15.6958 0.5 13.1524 0.5 10.5003C0.5 7.84821 1.55354 5.30475 3.42884 3.42944C5.30415 1.55413 7.84761 0.500597 10.4997 0.500597C12.9818 0.472956 15.3786 1.40534 17.1895 3.10302L14.3346 5.95793C13.3024 4.97453 11.9252 4.43587 10.4997 4.45798C7.89103 4.45798 5.67484 6.21793 4.88487 8.58785C4.46675 9.82982 4.46675 11.1745 4.88487 12.4165H4.88862C5.68234 14.7827 7.89478 16.5426 10.5035 16.5426C11.8509 16.5426 13.0084 16.1976 13.9058 15.5876H13.9021C14.4233 15.2425 14.8692 14.7953 15.2127 14.273C15.5562 13.7508 15.7903 13.1643 15.9008 12.549H10.4997V8.6991L19.9307 8.69785Z"
                    fill="currentColor"
                />
            </svg>
        )
    },
    openfinance_nubank: {
        name: "Nubank",
        icon: (
            <svg
                width="25"
                height="24"
                viewBox="0 0 500 275.9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M90.3 26.3C106.1 9.7 127 0 151.7 0c48 0 79.8 35 85.9 87.5 2 17.1 2 41.1 1.9 68.9v113h-66v-77.1s-.1-66-.5-78.4c-1.8-53.7-33.6-87.5-82.7-87.6-14.9 15.8-22.8 34.9-24 64.2-.2 4.1-.1 18.6-.1 37.6 0 9.9.1 21 .1 32.6v108.8H.3V150.8c0-4.1-.1-8.2-.1-12.3-.1-8.3-.3-16.6.1-24.9.7-13.8 3.1-27.4 9.6-40 14.7-28.8 44.9-47.4 77-47.4 1.1 0 2.2.1 3.4.1z"
                    fill="currentColor"
                />
                <path
                    d="M499.7 162.3c.4-8.3.3-16.6.1-24.9-.1-4.1-.1-8.2-.1-12.3V6.4h-66v108.8c0 11.6 0 22.7.1 32.6.1 19.1.1 33.6-.1 37.6-1.2 29.3-9.1 48.4-23.9 64.1-49.1 0-81-33.8-82.7-87.5-.4-12.3-.6-43-.6-78.4V6.3l-66 .1v113c0 27.8 0 51.9 1.9 68.9 6.1 52.5 37.9 87.5 85.9 87.5 24.6 0 45.6-9.7 61.4-26.3 1.1 0 2.2.1 3.4.1 32.2 0 62.3-18.6 77-47.4 6.5-12.6 8.9-26.1 9.6-39.9z"
                    fill="currentColor"
                />
            </svg>
        )
    },
    paypal_wallet: {
        name: "PayPal",
        icon: <PayPalIcon className="box-border h-7 w-7" />,
    },
    oxxo: {
        name: "OXXO",
        icon: <OxxoIcon className="box-border h-7 w-auto" />,
    },
    spei: {
        name: "SPEI",
        icon: <SpeiIcon className="box-border h-7 w-auto" />,
    },
    mercadopago_wallet: {
        name: "Mercado Pago",
        icon: <MercadoPagoIcon className="box-border h-7 w-7" />,
    },
    pagaleve: {
        name: "Parcelamento no Pix",
        icon: <ShortPagaleveIcon className="box-border h-7 w-7" />,
    },
    multi_card: {
        name: "Dois cartões",
        // Reusa o icone ja montado acima: duas definicoes do mesmo desenho sairiam
        // do lugar uma da outra na primeira vez que alguem mexesse numa delas.
        icon: PAYMENT_METHODS_ICONS.multi_card,
    },
    card_pix: {
        name: "Cartão + Pix",
        icon: PAYMENT_METHODS_ICONS.card_pix,
    },
}

export const PAYMENT_METHOD_DISPLAY_NAMES = Object.fromEntries(
    Object.entries(PAYMENT_METHODS_ICONS_WITH_NAME).map(([type, { name }]) => [type, name])
);

export const PAYMENT_METHOD_ICONIFY_ICONS = {
    pix: 'simple-icons:pix',
    pix_auto: 'simple-icons:pix',
    credit_card: 'ic:round-credit-card',
    boleto: 'ic:outline-barcode',
    picpay: 'simple-icons:picpay',
    applepay: 'simple-icons:applepay',
    googlepay: 'simple-icons:googlepay',
    openfinance_nubank: 'simple-icons:nubank',
    paypal_wallet: 'simple-icons:paypal',
    mercadopago_wallet: 'simple-icons:mercadopago',
    pagaleve: 'simple-icons:pix',
    oxxo: 'mdi:store-outline',
    spei: 'mdi:bank-transfer',
    debit_card: 'ic:round-credit-card',
    pse: 'mdi:bank-transfer',
    nequi: 'mdi:cellphone',
    safetypay: 'mdi:bank-transfer',
    threeDs: 'quill:creditcard',
    multi_card: 'ic:round-credit-card',
    card_pix: 'ic:round-credit-card',
    nupay: 'simple-icons:nubank',
};

export function getPaymentMethodIconifyIcon(type, fallbackIcon = 'mdi:credit-card-outline') {
    if (type && PAYMENT_METHOD_ICONIFY_ICONS[type]) {
        return PAYMENT_METHOD_ICONIFY_ICONS[type];
    }

    return fallbackIcon;
}